import React,{useState} from "react";
import {
  Modal,
  Button,
  Input,
  Row,
  Col,
  Typography,
  Divider,
  Form,
  message,
} from "antd";
import axios from 'axios'
import { gaEvent } from "analytics/analytics";
import * as GA from "constants/analytics";
const { Title, Text } = Typography;
export default function SendForApprovalModal({
  sendForApprovalModalVisible,
  collectionDetails,
  handleCancelApprovalModal,
  handleOkApprovalModal,
  saveAsDraft,
}) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false)
  const onFinish = (values) => {
    setLoading(true)

    const payload = {
      email:values?.email,
      collection_link:`https://app.sourcewiz.co/view-collection/${collectionDetails?.id}`,
      collection_name:collectionDetails?.collection_name,
  }

    axios.post(`${process.env.REACT_APP_DIRECTUS}custom/email-service/trace/send-for-approval`, payload).then(res=>{
      if (res.status === 200) {
        message.success('Successfully sent for approval');
        handleOkApprovalModal();
        setLoading(false);
        
      }
    }).catch(err=>{
      message.warn('Something went wrong');
      handleOkApprovalModal();
    });


  };
  const formItemLayout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
  };

  return (
    <>
      <Modal
        visible={sendForApprovalModalVisible}
        footer={null}
        onCancel={() => handleCancelApprovalModal()}
        centered={true}
      >
        <Form
          form={form}
          name="sendForApproval"
          onFinish={onFinish}
          {...formItemLayout}
        >
          <Row>
            <Col>
              <Title style={{ fontFamily: "Gilroy" }} level={3}>
                Send Catalogue for approval
              </Title>
            </Col>
          </Row>

          <Row>
            <Col>
              <Col>
                <Text type="secondary">
                  {collectionDetails?.collection_name}
                </Text>
              </Col>
            </Col>
          </Row>
          <Divider />
          <Row>
            <Col>
              <Title level={4}>Who are you sending this Catalogue?</Title>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Text type="secondary">
                An email will be sent to the following email address with the
                catalogue details
              </Text>
            </Col>
          </Row>

          <Row style={{ marginTop: "1.8rem" }}>
            <Col span={24}>
              <Form.Item
                name={"email"}
                label="Email"
                rules={[
                  {
                    required: true,
                    type: "email",
                    message: "Enter valid email",
                  },
                ]}
              >
                <Input size="large" 
                  onClick={() => {
                    gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.SEND_FOR_APPROVAL_INPUT_EMAIL);
                  }}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row justify="space-between" style={{ marginTop: "3rem" }}>
            <Col>
              <Button
                size="large"
                onClick={() => {
                  handleCancelApprovalModal();
                  saveAsDraft();
                  gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.SAVE_AS_DRAFT_BUTTON);
                }}
              >
                Save as Draft
              </Button>
            </Col>
            <Col>
              <Button
                size="large"
                type="primary"
                htmlType="submit"
                loading={loading}
                // onClick={() => handleOkApprovalModal()}
                onClick={() => {
                  gaEvent(GA.EVENT.CLICK, GA.CATEGORY.CREATE_COLLECTION, GA.DESCRIPTION.SEND_FOR_APPROVAL_BUTTON);
                }}
              >
                Send for Approval
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}
